import { InjectionToken } from '@angular/core';
import { NavigationConfig } from './navigation.types';

export const NAVIGATION_CONFIG = new InjectionToken<NavigationConfig>(
  'Config object for navigation'
);
